import AccountLayout from '@/components/feature/AccountLayout';

const steps = [
  { num: 1, title: 'Ảnh chân dung', desc: 'Ảnh chụp khuôn mặt rõ ràng, không che mặt.', icon: 'ri-user-smile-line', done: true },
  { num: 2, title: 'CMND/CCCD', desc: 'Ảnh mặt trước và mặt sau của căn cước công dân.', icon: 'ri-id-card-line', done: false },
  { num: 3, title: 'Xác nhận', desc: 'Hệ thống sẽ xét duyệt trong vòng 24 giờ.', icon: 'ri-check-double-line', done: false },
];

export default function Kyc() {
  return (
    <AccountLayout>
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold text-foreground-950 mb-2">Xác minh danh tính</h1>
        <p className="text-foreground-600 mb-6">Hoàn tất xác minh để nạp/rút tiền và giao dịch không giới hạn.</p>

        <div className="rounded-xl border border-accent-500/30 bg-accent-500/10 p-5 mb-6 flex items-start gap-3">
          <i className="ri-information-line text-accent-400 text-xl mt-0.5"></i>
          <div>
            <p className="text-sm font-semibold text-foreground-950">Tài khoản của bạn đang ở trạng thái: Chưa xác minh đầy đủ</p>
            <p className="text-sm text-foreground-600 mt-1">Bạn đã hoàn thành bước 1. Hãy tiếp tục các bước còn lại để kích hoạt đầy đủ tính năng.</p>
          </div>
        </div>

        <div className="space-y-4">
          {steps.map((s) => (
            <div key={s.num} className="rounded-xl border border-background-200/60 bg-background-100 p-5 flex items-start gap-4">
              <div className={`w-11 h-11 rounded-lg flex items-center justify-center ${s.done ? 'bg-emerald-500/15' : 'bg-background-200/60'}`}>
                <i className={`${s.icon} text-xl ${s.done ? 'text-emerald-400' : 'text-foreground-500'}`}></i>
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-semibold text-foreground-950">{s.title}</h3>
                  {s.done && <span className="px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-400 text-xs font-semibold">Đã hoàn thành</span>}
                </div>
                <p className="text-sm text-foreground-600 mt-1">{s.desc}</p>
              </div>
              <button
                className={`px-4 py-2 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors ${
                  s.done ? 'text-foreground-500 border border-background-300/60' : 'bg-primary-500 text-background-950 hover:bg-primary-600'
                }`}
              >
                {s.done ? 'Đã nộp' : 'Tải lên'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </AccountLayout>
  );
}